import React, { Component } from 'react';
import { connect } from 'react-redux';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import SingleCompanySelector from '../selectors/company/SingleCompanySelector';
import MultiCompanySelector from '../selectors/company/MultiCompanySelector';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import HighlightOnInAppMessage from '../inAppMessages/HighlightOninAppMessage';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import Underscore from "underscore";

const FORM_NAME = 'VAT_GROUPS_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
class VATGroupsForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            multiCompanySelection: []
        };
        this.multiCompanySelectionHandler = this.multiCompanySelectionHandler.bind(this);
        this.getExistingChildCompanies = this.getExistingChildCompanies.bind(this);
    }

    getExistingChildCompanies(parentCompanyId) {
        //Invalid parent id; simply return empty array
        if(Underscore.isEmpty(parentCompanyId)){
            return [];
        }
        //No matching vat group companies; simply return empty array
        var vatGroupCompanies = Underscore.filter(this.props.vatGroupList, function (item) {
            return item['companyId'] == parentCompanyId
        }) || [];
        
        //Matched vat group companies but no child companies, return empty array
        if(Underscore.isEmpty(vatGroupCompanies) || Underscore.isEmpty(vatGroupCompanies[0].childCompanies)) {
            return [];
        }

        return Underscore.map(vatGroupCompanies[0].childCompanies, function (item) {
            return item['companyId']
        });
    }

    multiCompanySelectionHandler(keyValuePairs) {
        log.clearDictionaryError(ALL_MESSAGES.BLANK_CHILD_COMPANY);
        log.clearDictionaryError(ALL_MESSAGES.CREATE_NEW_VAT_GROUP_SUCCESS);
        let fieldName = '';
        for(var i in keyValuePairs) {
            fieldName = i;
            let selectedCompanyIds = keyValuePairs[i]; 
            if(Underscore.isEmpty(selectedCompanyIds)) {
                this.props.onFieldChange(this.props.FORM_NAME_FOR_VAT_GROUPS, fieldName, []);
            } else {
                this.props.onFieldChange(this.props.FORM_NAME_FOR_VAT_GROUPS, fieldName, [].concat(selectedCompanyIds));
            }
        }
    }

    filterSelectionHandler(keyValuePairs) {
        log.clearDictionaryError(ALL_MESSAGES.BLANK_PARENT_COMPANY);
        log.clearDictionaryError(ALL_MESSAGES.CREATE_NEW_VAT_GROUP_SUCCESS);
        var parentCompanyId = this.props.formData.fieldValues.parentCompanyId;
        var fieldName = '', value = '';
       for(var i in keyValuePairs) {
            fieldName = i;
            //For single company selector
            value = keyValuePairs[i];
            this.props.onFieldChange(this.props.FORM_NAME_FOR_VAT_GROUPS, fieldName, value);
        }
    }

    onSubmitForm() {
        log.debug('onSubmitForm(): ', this.props.formData);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_PARENT_COMPANY);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_CHILD_COMPANY);
        let fieldsOk = true;


        log.setDictionaryMessage(ALL_MESSAGES.CREATE_NEW_VAT_GROUP_SUCCESS);


        if (!this.props.formData || typeof this.props.formData.fieldValues !== 'object') {
            return; // TODO: Maybe a dialog to confirm blank entry?
        }

        if (typeof (this.props.companySelectionFieldName === 'childCompanyId' ? this.props.formData.fieldValues.childCompanyId : this.props.formData.fieldValues.parentCompanyId) !== 'string'
            || (this.props.companySelectionFieldName === 'childCompanyId' ? this.props.formData.fieldValues.childCompanyId.trim().length :
                this.props.formData.fieldValues.parentCompanyId.trim().length) === 0)
                
        {
            log.debug('onSubmitForm(): error blank companyId');
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_PARENT_COMPANY);
            
            log.clearSuccessMessage('successMessage_NewVATGroup');
            log.clearDictionaryError(ALL_MESSAGES.CREATE_NEW_VAT_GROUP_SUCCESS);
            fieldsOk = false;

        }

        if (this.props.companyMultiSelectionFieldName === 'parentCompanyIds' ? this.props.formData.fieldValues.parentCompanyIds.length === 0 : this.props.formData.fieldValues.childCompanyIds.length === 0)
        {
            log.debug('onSubmitForm(): error blank companyIds');
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_CHILD_COMPANY);
            log.clearSuccessMessage('successMessage_NewVATGroup');
            log.clearDictionaryError(ALL_MESSAGES.CREATE_NEW_VAT_GROUP_SUCCESS);
            fieldsOk = false;
        }

        if (!fieldsOk) {
            return;
        }
        let parentCompanyId = this.props.formData && this.props.formData.fieldValues && this.props.formData.fieldValues.parentCompanyId;
        let existingChildCompanies = this.getExistingChildCompanies(parentCompanyId);
        let selectedChildCompanyIds = this.props.formData.fieldValues.childCompanyIds;
        if(!Underscore.isEmpty(existingChildCompanies)) {
            //Add new existing company ids if not selected
            existingChildCompanies.forEach( (companyId) => {
                if(!selectedChildCompanyIds.includes(companyId)) {
                    selectedChildCompanyIds.push(companyId);
                }
            });
        }
        else {
            selectedChildCompanyIds = selectedChildCompanyIds.concat(existingChildCompanies);
        } 
        this.props.submitHandler(this.props.formData.fieldValues.parentCompanyId,this.props.formData.fieldValues.childCompanyIds);
        this.props.doResetForm(this.props.FORM_NAME_FOR_VAT_GROUPS);
    }

    render() {
        log.debug('render(): ', this.props);
        const fieldValues = this.props.formData && this.props.formData.fieldValues;
        if (!fieldValues) {
            return (<div>Waiting for form to load</div>);
        }

        return (
            <ReadOnlyWrapper>
                <fieldset>
                    <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationError" />
                    <label className="mt0">{this.props.companySelectionLabel}</label>
                    <HighlightOnInAppMessage
                        scopes={[FORM_NAME]}
                        messageIds={[ALL_MESSAGES.BLANK_PARENT_COMPANY]}
                    >
                    <SingleCompanySelector
                        companyList={this.props.companyList}
                        fieldName={this.props.companySelectionFieldName}
                        selectionHandler={this.filterSelectionHandler.bind(this)}
                        selectedCompanyId={fieldValues.parentCompanyId || ''}
                    /></HighlightOnInAppMessage>

                    <label className="mt15 mb5">{this.props.companyMultiSelectionLabel}</label>
                    <HighlightOnInAppMessage
                        scopes={[FORM_NAME]}
                        messageIds={[ALL_MESSAGES.BLANK_CHILD_COMPANY]}
                    >
                    <MultiCompanySelector
                        companyList={this.props.companyList}
                        fieldName={this.props.companyMultiSelectionFieldName}
                        selectionHandler={this.multiCompanySelectionHandler}
                        selectedCompanyIds={fieldValues.childCompanyIds || []}
                    />
                    <span className="mt10 display-block">
                        <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationSuccess" />
                    </span>
                    </HighlightOnInAppMessage>
                    <button className="primary" onClick={this.onSubmitForm.bind(this)}><LanguageStringResolver string='vatGroups_CreateVATGroup'/></button>
                </fieldset>
            </ReadOnlyWrapper>
        );
    }
    componentWillUnmount() {
        this.props.doDestroyForm(this.props.FORM_NAME_FOR_VAT_GROUPS);
    }
    UNSAFE_componentWillMount() {
        log.clearDictionaryError(ALL_MESSAGES.BLANK_PARENT_COMPANY);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_CHILD_COMPANY);
        this.props.doInitialiseForm(this.props.FORM_NAME_FOR_VAT_GROUPS, this.props.vatGroup);
    }

    onFieldChangeHandlerFactory(fieldName) {
        return (evt) => {
            this.props.onFieldChange(this.props.FORM_NAME_FOR_VAT_GROUPS, fieldName, evt.target.value)
        }
    }
    
    onClearForm() {
        log.debug('onClearForm(): ');
        this.props.doClearForm(this.props.FORM_NAME_FOR_VAT_GROUPS);

    }
}

function mapStateToProps(state, props) {
    log.debug('mapStateToProps(): ', state);
    log.debug('mapStateToProps(): props', props);

    // Because of the way the UX is designed, with multiple users allowed to be edited, we will have multiple forms too
    // However we need to construct a unique form name per user, for the FORMS_CONTROLLER not to mix them up.
    // Using the user's email as a suffix should work for existing users, but we will need to think about new users.
    const formNameForVATGroups = FORM_NAME+'_FOR_' + 'Invite';
    return {
        // Almost all components will need to use language strings, so add them to the props from the global state
        formData: (state.managedUxForms && state.managedUxForms.forms[formNameForVATGroups]),
        FORM_NAME_FOR_VAT_GROUPS: formNameForVATGroups
        // TODO: Add additional data we want to extract from the global state and inject into the props here
    };
}


function mapDispatchersToProps(dispatch) {
    return {
        // Standard form actions
        doInitialiseForm: (formNameForVATGroups,initialValues) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(formNameForVATGroups, initialValues));
        },
        doResetForm: (formNameForVATGroups) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(formNameForVATGroups));
        },
        doClearForm: (formNameForVATGroups) => {
            log.debug('onClearForm(): ');
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(formNameForVATGroups));
        },
        onFieldChange: (formNameForVATGroups, fieldName, value) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(formNameForVATGroups, fieldName, value));
        },
        doFormSubmitted: (formNameForVATGroups) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(formNameForVATGroups));
        },
        doDestroyForm: (formNameForVATGroups) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(formNameForVATGroups));
        }
        //TODO: Add dispatchers (actions we expect controllers to perform) here.
    }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(VATGroupsForm);
